import React from 'react';

import {AsteriskDisclaimerTermsConditions} from '../TermsConditionsTexts/AsteriskDisclaimerTermsConditions/AsteriskDisclaimerTermsConditions';
import {DeclarationTermsConditions} from '../TermsConditionsTexts/DeclarationTermsConditions';
import {InitialTextTermsConditions} from '../TermsConditionsTexts/InitialTextTermsConditions';
import {LegendTermsConditions} from '../TermsConditionsTexts/LegendTermsConditions';
import {ObservationsTermsConditions} from '../TermsConditionsTexts/ObservationsTermsConditions';
import {TableProductsTermsConditions} from '../TermsConditionsTexts/TableProductsTermsConditions';
import './TermsConditions.style.scss';

export const TermsConditions = () => {
  return (
    <section className="terms-conditions">
      <InitialTextTermsConditions />
      <TableProductsTermsConditions />
      <AsteriskDisclaimerTermsConditions />
      <ObservationsTermsConditions />
      <LegendTermsConditions />
      <DeclarationTermsConditions />
    </section>
  );
};
